export default "__VITE_ASSET__ByAo1NJ$__"